import {
  TestWebPushFormProvider,
  WebPushFormProvider,
  useModalsContext,
} from 'modules/webPush/WebPushV2/context';
import { ModalProps, ModalType, ModalsContextState } from 'modules/webPush/WebPushV2/types';
import { FC, PropsWithChildren } from 'react';
import { NoOpComponent } from 'utils/reactHelpers';
import { ConfigureIntegrationModal } from './ConfigureIntegrationModal';
import { DeleteIntegrationModal } from './DeleteIntegrationModal';
import { TestWebPushModal } from './TestWebPushModal';

const withContext =
  (Component: FC<ModalProps>, Provider: FC<PropsWithChildren>) => (props: ModalProps) => (
    <Provider>
      <Component {...props} />
    </Provider>
  );

const MODALS_MAPPER = {
  [ModalType.ConfigureIntegrationModal]: withContext(
    ConfigureIntegrationModal,
    WebPushFormProvider,
  ),
  [ModalType.DeleteIntegrationModal]: DeleteIntegrationModal,
  [ModalType.TestWebPushModal]: withContext(TestWebPushModal, TestWebPushFormProvider),
};

const createModalsComponent =
  (
    mapper: Record<string, (modalProps: ModalProps) => JSX.Element>,
    useContext: () => ModalsContextState,
  ) =>
  () => {
    const { openedModals, closeModal } = useContext();

    return openedModals.map(({ modalType, modalProps = {} }) => {
      const onClose = () => closeModal(modalType);
      const Modal = mapper[modalType] || NoOpComponent;
      return <Modal key={modalType} {...modalProps} onClose={onClose} />;
    });
  };

export const Modals = createModalsComponent(MODALS_MAPPER, useModalsContext);
